import SENSITIVITY from '../../assets/scalp/sample/SENSITIVITY.png';
import OIL from '../../assets/scalp/sample/OIL.png';
import HAIR_THICKNESS from '../../assets/scalp/sample/HAIR_THICKNESS.png';
import HAIR_QUANTITY from '../../assets/scalp/sample/HAIR_QUANTITY.png';
import HAIR_FOLLICLE_DENSITY from '../../assets/scalp/sample/HAIR_FOLLICLE_DENSITY.png';
import DEAD_SKIN from '../../assets/scalp/sample/DEAD_SKIN.png';
import HAIR_PER_HAIR_FOLLICLE from '../../assets/scalp/sample/HAIR_PER_HAIR_FOLLICLE.png';
import ORIGIN from '../../assets/scalp/sample/ORIGIN.png';

const analysisItems = [
  {
    item: 'DEAD_SKIN',
    value: 0.01,
    average: 2.0857894819033773,
    image: DEAD_SKIN,
  },
  {
    item: 'SENSITIVITY',
    value: 4.99,
    average: 5.976947399934656,
    image: SENSITIVITY,
  },
  { item: 'OIL', value: 0, average: 0.1351578952646569, image: OIL },
  { item: 'WATER', value: 95.77, average: 80.85326307196367, image: '' },
  { item: 'GAS', value: 27, average: 70.52631578947368, image: '' },
  { item: 'TEMPERATURE', value: 34.78, average: 35.4821052350496, image: '' },
  {
    item: 'HAIR_FOLLICLE_DENSITY',
    value: 13,
    average: 15.189473684210526,
    image: HAIR_FOLLICLE_DENSITY,
  },
  {
    item: 'HAIR_PER_HAIR_FOLLICLE',
    value: 1,
    average: 1.4317894659544292,
    image: HAIR_PER_HAIR_FOLLICLE,
  },
  {
    item: 'HAIR_QUANTITY',
    value: 11.51,
    average: 21.35126314665142,
    image: HAIR_QUANTITY,
  },
  {
    item: 'HAIR_THICKNESS',
    value: 0.17,
    average: 0.2174736837023183,
    image: HAIR_THICKNESS,
  },
];

export const scalpResultDummaytData = {
  analysisDate: '2022-07-12T00:46:59.825Z',
  analysisItems,
  id: 1,
  scalpPoint: 'FOREHEAD_CENTER',
  hexagonalScores: {
    averages: {
      deadSkin: 90.8632,
      hairFollicleDensity: 69.8526,
      hairQuantity: 67.7368,
      scalpHealthScore: 76.8105,
      sensitivity: 82.3368,
      temperature: 93.2526,
      water: 85.4632,
    },
    my: {
      deadSkin: 99,
      hairFollicleDensity: 66,
      hairPerHairFollicle: 72,
      hairQuantity: 46,
      hairThickness: 45,
      scalpHealthScore: 70,
      sensitivity: 77,
      temperature: 99,
      water: 98,
    },
  },
};
export const SCALP_SENSITIVITY_DATA = {
  analysisDate: '2022-07-12',
  analysisItemType: 'SENSITIVITY',
  id: 1,
  image: SENSITIVITY,
  myAverage: 30.9403,
  scalpPoint: 'FOREHEAD',
  value: 30,
  averages: {
    my: 30.9403,
    all: {
      average: 30.75,
      population: 128,
    },
  },
};

export const SCALP_HAIR_QUANTITY = {
  analysisDate: '2022-07-12',
  analysisItemType: 'HAIR_QUANTITY',
  id: 1,
  image: HAIR_QUANTITY,
  myAverage: 30.9403,
  scalpPoint: 'FOREHEAD',
  value: 30,
  averages: {
    my: 33.9403,
    all: {
      average: 36.75,
      population: 88,
    },
  },
};

export const SCALP_HAIR_FOLLICLE_DENSITY = {
  analysisDate: '2022-07-12',
  analysisItemType: 'HAIR_FOLLICLE_DENSITY',
  id: 1,
  image: HAIR_FOLLICLE_DENSITY,
  myAverage: 30.9403,
  scalpPoint: 'FOREHEAD',
  value: 30,
  averages: {
    my: 33.9403,
    all: {
      average: 36.75,
      population: 88,
    },
  },
};
export const SCALP_DEAD_SKIN_DATA = {
  analysisDate: '2022-07-12',
  analysisItemType: 'DEAD_SKIN',
  id: 1,
  image: DEAD_SKIN,
  myAverage: 10.9403,
  scalpPoint: 'FOREHEAD',
  value: 10,
  averages: {
    my: 10.9403,
    all: {
      average: 10.75,
      population: 128,
    },
  },
};
export const SCALP_HEALTH_SCORE_DATA = {
  analysisDate: '2022-07-12',
  analysisItemType: 'SCALP_HEALTH_SCORE',
  hexagonalScores: {
    my: {
      deadSkin: 100,
      hairFollicleDensity: 60,
      hairQuantity: 58,
      sensitivity: 86,
      temperature: 100,
      water: 80,
    },
    averages: {
      deadSkin: 90.2955,
      hairFollicleDensity: 69.5227,
      hairQuantity: 68.3068,
      scalpHealthScore: 76.75,
      sensitivity: 82.4205,
      temperature: 92.8409,
      water: 85.1136,
    },
  },
  id: 1,
  image: ORIGIN,
  myAverage: 73.9403,
  scalpPoint: 'FOREHEAD',
  value: 70,
  averages: {
    my: 73.9403,
    all: {
      average: 76.75,
      population: 88,
    },
  },
};
